<div class="flex flex-col bg-card overflow-hidden h-full border border-black-200">
  <header
    appAccountColorBackground
    #backgroundDirective="appAccountColorBackground"
    [colorName]="headerColor"
    class="flex flex-row justify-between items-center p-3 font-semibold border-b border-black-200 h-ts-panel-header"
  >
    <div class="flex flex-row items-center gap-4">
      <p [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'" class="uppercase">
        {{ title || '-' }}
      </p>
      <ng-content select="[ts-panel-title-side]"></ng-content>
    </div>

    @if (displayPanelOptions) {
      <ts-button
        [iconColor]="backgroundDirective.isContrastLight ? 'white' : 'black'"
        type="icon"
        icon="more_vert"
        [disabled]="disablePanelOptions"
        (click)="panelOptionsClicked.emit()"
      ></ts-button>
    }
  </header>
  @if (!loading) {
    <ng-content select="[ts-panel-content]"></ng-content>
  } @else {
    <div class="flex flex-col items-center justify-center h-full">
      <mat-spinner diameter="80"></mat-spinner>
    </div>
  }
</div>
